/* ヘッダーにある検索・カテゴリの表示不具合を調整するためのJSです*/

(function(){

  var __skipCategoryClickUntil = 0;
  var lastCategoryOpenTime = 0;

function handleCategoryToggle(btn){
  var wasSearchOpen = isSearchOpen();

  // メニュー取得（再オープン判定用）
  function getMenu(){
    var li = btn.closest('li');
    if (!li) return null;
    return li.querySelector('.MegaMenu');
  }
  function isMenuOpen(menu){
    return menu && window.getComputedStyle(menu).display !== 'none';
  }

  if (wasSearchOpen) {
    // 検索を閉じる
    closeSearchSoft();

    // 外側閉じ誤爆は長めに抑止（iOSの遅延イベント吸収）
    suppressOutsideClose(1200);

    // Search overlay 背面化（あなたの現状ロジック維持）
    applyOverlayBackFix(true);

    // PageOverlay が消えたら「少し待ってから」カテゴリを開く
    waitUntilPageOverlayGone(function(){

      // ★ここが肝：theme.js の“遅れてくる閉じ処理”を先に通す
      setTimeout(function(){
        toggleCategory(btn);

        // ★保険：もし theme.js がこの直後に閉じたら、1回だけ開き直す
        setTimeout(function(){
          var menu = getMenu();
          if (menu && !isMenuOpen(menu)) {
            // もう一度だけ開く（トグルだと閉じる可能性があるので open を強制）
            // openCategory がスコープ内にある前提（あなたのコードならある）
            openCategory(btn, menu);
          }
        }, 220);

        // overlay背面化解除（少し長め）
        setTimeout(function(){
          applyOverlayBackFix(false);
        }, 300);

      }, 220); // ← iPhone13 mini 対策。180〜260で効くことが多いのでまず220
    });

  } else {
    // 検索が開いてない時は従来どおり
    toggleCategory(btn);
  }
}


  /* =========================
     Utility
  ========================= */
  function qs(sel, root){ return (root || document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }


  // ===== iOS対策：外側クリックで閉じる処理を短時間だけ無効化 =====
  var suppressOutsideCloseUntil = 0;

  function suppressOutsideClose(ms){
    suppressOutsideCloseUntil = Date.now() + (ms || 400);
  }

  function isOutsideCloseSuppressed(){
    return Date.now() < suppressOutsideCloseUntil;
  }


  /* =========================
     Category-only overlay (does NOT touch Search overlay)
  ========================= */
  function ensureCategoryOverlay() {
    var ov = document.getElementById('CategoryOverlay');
    if (ov) return ov;

    ov = document.createElement('div');
    ov.id = 'CategoryOverlay';
    ov.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ov);
    return ov;
  }

  function showCategoryOverlay() {
    var ov = ensureCategoryOverlay();
    ov.setAttribute('aria-hidden', 'false');
    ov.classList.add('is-visible');
  }

  function hideCategoryOverlay() {
    var ov = ensureCategoryOverlay();
    ov.setAttribute('aria-hidden', 'true');
    ov.classList.remove('is-visible');
  }

  function anyCategoryOpen() {
    return qsa('.Header__Navigation.Sub__Menu .MegaMenu').some(function(m){
      return window.getComputedStyle(m).display !== 'none';
    });
  }

  function hideCategoryOverlayIfNoMenuOpen() {
    if (!anyCategoryOpen()) hideCategoryOverlay();
  }

  /* =========================
     Search helpers (Prestige)
  ========================= */
  function isSearchOpen() {
    var t = qs('[data-action="toggle-search"]');
    if (t && t.getAttribute('aria-expanded') === 'true') return true;

    var s = document.getElementById('Search');
    if (s && s.getAttribute('aria-hidden') === 'false') return true;

    return false;
  }

  function closeSearchSoft() {
    var closeBtn = qs('#Search [data-action="close-search"]');
    if (closeBtn) closeBtn.click();

    // 保険（効くテーマだけ効く）
    try { document.dispatchEvent(new CustomEvent('search:close')); } catch(e){}
  }

  /* =========================
     Overlay back-fix (Search -> Category)
  ========================= */
  function applyOverlayBackFix(on){
    // CSS側で html._catFromSearchFix body .PageOverlay を背面に
    if (on) document.documentElement.classList.add('_catFromSearchFix');
    else document.documentElement.classList.remove('_catFromSearchFix');
  }



  /* PageOverlay が “is-visible外れた瞬間” を待つ（固定msより安定） */
  function waitUntilPageOverlayGone(done) {
    var overlay = document.querySelector('.PageOverlay');
    if (!overlay) { done(); return; }

    var start = performance.now();

    function isGone() {
      return !overlay.classList.contains('is-visible');
    }

    if (isGone()) { done(); return; }

    var mo = new MutationObserver(function(){
      if (isGone()) {
        mo.disconnect();
        done();
      }
    });

    try {
      mo.observe(overlay, { attributes: true, attributeFilter: ['class'] });
    } catch(e) {
      // observe失敗時はフォールバック
      done();
      return;
    }

    // 念のためタイムアウト（最大1200ms）
    (function timeoutLoop(){
      if (isGone()) return;
      if (performance.now() - start > 1200) {
        try { mo.disconnect(); } catch(e){}
        done();
        return;
      }
      requestAnimationFrame(timeoutLoop);
    })();
  }

  /* =========================
     Category menu control
  ========================= */
  function initCategoryMenus() {
    qsa('.Header__Navigation.Sub__Menu .MegaMenu').forEach(function(menu){
      menu.setAttribute('aria-hidden', 'true');
      menu.style.display = 'none';

      var li = menu.closest('li');
      if (li) li.classList.remove('is-open','is-active','is-expanded');
      menu.classList.remove('is-open','is-active','is-expanded','is-visible');

      var btn = li ? qs('[data-action="toggle-category"]', li) : null;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });

    hideCategoryOverlay();
  }

  function getCategoryMenu(btn) {
    var li = btn.closest('li');
    if (!li) return null;
    return qs('.MegaMenu', li);
  }

  function openCategory(btn, menu) {
    lastCategoryOpenTime = Date.now(); // ★追加

    var li = btn.closest('li');

    menu.setAttribute('aria-hidden', 'false');
    menu.style.display = 'block';
    btn.setAttribute('aria-expanded', 'true');

    if (li) li.classList.add('is-open','is-active','is-expanded');
    menu.classList.add('is-open','is-active','is-expanded','is-visible');

    requestAnimationFrame(function(){
      showCategoryOverlay();
      suppressOutsideClose(600); // ★追加（ゴーストクリック防止）

    });
  }

  function closeCategory(btn, menu) {
    var li = btn.closest('li');

    menu.setAttribute('aria-hidden', 'true');
    menu.style.display = 'none';
    btn.setAttribute('aria-expanded', 'false');

    if (li) li.classList.remove('is-open','is-active','is-expanded');
    menu.classList.remove('is-open','is-active','is-expanded','is-visible');

    hideCategoryOverlayIfNoMenuOpen();
    suppressOutsideClose(300);
  }

  function toggleCategory(btn) {
    var menu = getCategoryMenu(btn);
    if (!menu) return;

    var isOpenNow = window.getComputedStyle(menu).display !== 'none';
    if (isOpenNow) closeCategory(btn, menu);
    else openCategory(btn, menu);
  }

  function closeAllCategories() {
    qsa('.Header__Navigation.Sub__Menu [data-action="toggle-category"]').forEach(function(btn){
      var menu = getCategoryMenu(btn);
      if (!menu) return;

      menu.setAttribute('aria-hidden','true');
      menu.style.display = 'none';
      btn.setAttribute('aria-expanded','false');

      var li = btn.closest('li');
      if (li) li.classList.remove('is-open','is-active','is-expanded');
      menu.classList.remove('is-open','is-active','is-expanded','is-visible');
    });

    hideCategoryOverlay();
  }

  /* init */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryMenus);
  } else {
    initCategoryMenus();
  }

 // iOS用：touchで先に処理（click二重発火を確実に潰す）
var __catHandledByTouch = false;

document.addEventListener('touchend', function(e){
  var btn = e.target.closest('a[data-action="toggle-category"]');
  if (!btn) return;

  // ★clickがかなり遅れて来る端末があるので長めにガード
  __catHandledByTouch = true;
  __skipCategoryClickUntil = Date.now() + 2000;

  e.preventDefault();
  e.stopImmediatePropagation();

  handleCategoryToggle(btn);

  // ★安全に解除
  setTimeout(function(){
    __catHandledByTouch = false;
  }, 2100);

}, { capture: true, passive: false });


 

  /* =========================
     Category click (capture)
  ========================= */
// カテゴリクリック（capture）
document.addEventListener('click', function(e){
  var btn = e.target.closest('a[data-action="toggle-category"]');
  if (!btn) return;

  // ★touchendで処理した直後はclickは絶対に無視
  if (__catHandledByTouch) return;
  if (Date.now() < __skipCategoryClickUntil) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  handleCategoryToggle(btn);
}, true);




document.addEventListener('click', function(e){

  // ▼カテゴリを開いてから300ms以内は閉じない（iOS誤爆対策）
  if (Date.now() - lastCategoryOpenTime < 350) return;

  if (e.target.closest('.Header__Navigation.Sub__Menu')) return;
  if (e.target.closest('#Search')) return;
  if (e.target.closest('.PageOverlay')) return;

  if (e.target.closest('#CategoryOverlay')) {
    closeAllCategories();
    return;
  }

  closeAllCategories();
});


  /* search click closes categories */
  document.addEventListener('click', function(e){
    var searchBtn = e.target.closest('[data-action="toggle-search"], [data-action="open-search"]');
    if (!searchBtn) return;
    closeAllCategories();
  }, true);

})();
